<template>
  <div class="step-form">
    <div class="step-form-section">
      <div class="inner-container thirdstep-filters">
        <div class="form-group thirdstep-filters-budget">
          <label for="budgetFrom">
            {{ $t("labels.budget") }}
          </label>
          <div style="margin-top: 24px; margin-bottom: 24px">
            <slider
              v-if="budget.length"
              v-model="budget"
              class="slider-custom"
              :step="sliderConfig.step"
              :min="sliderConfig.min"
              :max="sliderConfig.max"
              :merge="sliderConfig.merge"
              :tooltip-position="sliderConfig.tooltipPosition"
              :format="sliderConfig.sliderFormat"
              @update="budgetSliderUpdate"
            />
          </div>
        </div>
        <div class="form-group thirdstep-filters-prefs">
          <label for="budgetFrom">
            {{ $t("labels.yourPriorities") }}
          </label>
          <div class="prefs-wrapper">
            <div class="prefs-tile" v-if="mainArea != null">
              <span>{{ getAreaName }}</span>
              <i class="far fa-times" @click="removeMainArea"></i>
            </div>
            <div class="prefs-tile" v-if="mainDestiny != null">
              <span>{{ getDestinyName }}</span>
              <i class="far fa-times" @click="removeMainDestiny"></i>
            </div>
            <div class="prefs-tile" v-for="(item, index) in selectedEquipment" :key="index">
              <span>{{ getEquipmentName(item) }}</span>
              <i class="far fa-times" @click="removeEquipment(item)" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="expandable-section"
      :class="{ 'bottom-separator': advancedFiltersSummaryVisible }"
      v-if="advancedFiltersExists()"
    >
      <div
        class="expandable-section-btn"
        @click="advancedFiltersSummaryVisible = !advancedFiltersSummaryVisible"
      >
        <span>
          {{ !advancedFiltersSummaryVisible ? $t("labels.seaAll") : $t("labels.hideAll") }}
        </span>
        <i :class="advancedFiltersSummaryVisible ? 'far fa-chevron-up' : 'far fa-chevron-down'"></i>
      </div>
      <transition name="fade">
        <other-preferences v-show="advancedFiltersSummaryVisible" />
      </transition>
    </div>
  </div>
</template>
<script>
// vuex
import { mapFields } from "vuex-map-fields";

// components
import Slider from "@vueform/slider/dist/slider.vue2.js";
import OtherPreferences from "@/components/App/OtherPreferences";

// css
import "./StepForm.scss";

// methods
import setCookie from "@/utils/setCookie";
import updateUrlParams from "@/router/middleware/updateUrlParamsMiddleware";

// enums
import { genderEnum } from "@/enums/genderEnum";

export default {
  name: "ThirdStep",
  data() {
    return {
      genderEnum,
      advancedFiltersSummaryVisible: false,
      sliderConfig: {
        min: 0,
        max: 30000,
        step: 500,
        merge: 8000,
        tooltipPosition: "bottom",
        sliderFormat: function (value) {
          var parts = value.toString().split(".");
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
          return parts.join(".");
        },
      },
      equipment: [],
    };
  },
  computed: {
    ...mapFields([
      "filters.age",
      "filters.height",
      "filters.budget",
      "filters.gender",
      "filters.selectedEquipment",
      "filters.color",
      "filters.paintFinish",
      "filters.wheelSize",
      "filters.frameFabric",
      "filters.rearShockAbsorber",
      "filters.gearsNumber",
      "filters.electricBike",
      "filters.optionalDestinies",
      "filters.optionalAreas",
      "filters.mainArea",
      "filters.mainDestiny",
      "areas",
      "destinies",
      "equipments",
    ]),
    getAreaName() {
      if (this.areas.length) {
        return this.areas.filter((el) => el.Value === +this.mainArea)[0].Text;
      }
      return null;
    },
    getDestinyName() {
      if (this.destinies.length) {
        return this.destinies.filter((el) => el.Value === +this.mainDestiny)[0].Text;
      }
      return null;
    },
  },
  watch: {
    selectedEquipment: function (newVal) {
      setCookie("selectedEquipment", newVal.join(), this);
      updateUrlParams();
    },
    budget: function (newVal) {
      setCookie("budget", newVal.join(), this);
      updateUrlParams();
    },
    mainArea: function (newVal) {
      setCookie("mainArea", newVal, this);
      updateUrlParams();
    },
    mainDestiny: function (newVal) {
      setCookie("mainDestiny", newVal, this);
      updateUrlParams();
    },
  },
  methods: {
    getEquipmentName(index) {
      if (this.equipments.length) {
        return this.equipments.filter((el) => el.Value === +index)[0].Text;
      }
    },
    budgetSliderUpdate: function (e) {
      this.budget = e;
    },
    removeEquipment(item) {
      const index = this.selectedEquipment.indexOf(item);
      if (index > -1) {
        this.selectedEquipment.splice(index, 1);
      }
      updateUrlParams();
    },
    // used in mounted hook. Retrieves filters values from browser cookies
    getCookies() {
      const age = this.$cookies.get("age");
      const height = this.$cookies.get("height");
      const gender = this.$cookies.get("gender");
      if (age) this.age = +age;
      if (height) this.height = +height;
      if (gender != null) this.gender = +gender;

      const budget = this.$cookies.get("budget");
      if (budget) {
        let cookieBudget = budget.split(",");
        if (cookieBudget) {
          for (let i = 0; i < cookieBudget.length; i++) {
            cookieBudget[i] = +cookieBudget[i];
          }
          this.budget = cookieBudget;
        }
      }

      const color = this.$cookies.get("color");
      const paintFinish = this.$cookies.get("paintFinish");
      const wheelSize = this.$cookies.get("wheelSize");
      const frameFabric = this.$cookies.get("frameFabric");
      const rearShockAbsorber = this.$cookies.get("rearShockAbsorber");
      const gearsNumber = this.$cookies.get("gearsNumber");
      const electricBike = this.$cookies.get("electricBike");
      const optionalDestinies = this.$cookies.get("optionalDestinies");
      const optionalAreas = this.$cookies.get("optionalAreas");

      if (color) this.color = color;
      if (paintFinish) this.paintFinish = paintFinish;
      if (wheelSize) this.wheelSize = wheelSize;
      if (frameFabric) {
        let cookieFrameFabric = frameFabric.split(",");
        if (cookieFrameFabric) {
          this.frameFabric = cookieFrameFabric;
        }
      }
      if (rearShockAbsorber) this.rearShockAbsorber = rearShockAbsorber;
      if (gearsNumber) this.gearsNumber = gearsNumber;
      if (electricBike) this.electricBike = electricBike;
      if (optionalDestinies) {
        let cookieOptionalDestinies = optionalDestinies.split(",");
        if (cookieOptionalDestinies) {
          this.optionalDestinies = cookieOptionalDestinies;
        }
      }
      if (optionalAreas) {
        let cookieOptionalArea = optionalAreas.split(",");
        if (cookieOptionalArea) {
          this.optionalAreas = cookieOptionalArea;
        }
      }

      const selectedEquipment = this.$cookies.get("selectedEquipment");
      if (selectedEquipment) {
        // selected equipment IDs are saved in cookies as string with commas
        // so here I make an array of strings of it
        let cookieSelectedEquipment = selectedEquipment.split(",");
        if (cookieSelectedEquipment) {
          for (let i = 0; i < cookieSelectedEquipment.length; i++) {
            // changing array of strings to array of numbers
            cookieSelectedEquipment[i] = +cookieSelectedEquipment[i];
          }
          // assign prepared array of numbers to Vuex store field
          this.selectedEquipment = cookieSelectedEquipment;
        }
      }
    },
    advancedFiltersExists() {
      return (
        this.color ||
        this.wheelSize ||
        this.rearShockAbsorber ||
        this.electricBike ||
        (this.optionalAreas && this.optionalAreas.length) ||
        this.paintFinish ||
        (this.frameFabric && this.frameFabric.length) ||
        (this.gearsNumber && this.gearsNumber.length) ||
        (this.optionalDestinies && this.optionalDestinies.length)
      );
    },
    removeMainArea() {
      this.mainArea = null;
    },
    removeMainDestiny() {
      this.mainDestiny = null;
    },
  },
  mounted() {
    // set filters values depending on cookies
    this.getCookies();
  },
  components: {
    Slider,
    OtherPreferences,
  },
};
</script>
<style scoped>
.fade-enter-active {
  transition: 0.5s ease;
}
.fade-leave-active {
  transition: 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
<style src="@vueform/slider/themes/default.css"></style>
